import * as React from 'react';
import { useRef } from 'react';

import { use$ } from '@legendapp/state/react';
import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled, { css } from 'styled-components';

import { landscapeMediaMixin } from '../../hooks/use-vertical-breakpoint';

import { fullscreenStore, interiorStore } from '../../store';
import { testId } from '../../test-utils/constants';
import { OptionSelection } from './options-selection';
import { PickerType } from './picker';

export const OptionSelector = () => {
	const isFullscreenMode = use$(fullscreenStore.isFullscreenMode);
	const isInteriorMode = use$(interiorStore.isInteriorLoaded);
	const parentRef = useRef<HTMLDivElement>(null);

	return (
		<ControlsWrapper ref={parentRef} data-testid={testId('Controls_Wrapper')} $isFullscreenMode={isFullscreenMode}>
			{isInteriorMode ? (
				<OptionSelection pickerType={PickerType.Interior} />
			) : (
				<>
					<OptionSelection pickerType={PickerType.Color} />
					<OptionSelection pickerType={PickerType.Rim} />
				</>
			)}
		</ControlsWrapper>
	);
};

export const SliderMagicMixin = (isDoubleSliderVisible: boolean) => css`
	width: ${() => (isDoubleSliderVisible ? '100%' : 'auto')};
	overflow: ${() => (isDoubleSliderVisible ? 'hidden' : 'initial')};
`;

const DoubleSliderMixin = () => css`
	flex-direction: row-reverse;
	align-items: center;
	justify-content: space-between;

	gap: ${props => props.theme.size.static350};
`;

const ControlsWrapper = styled.div<{ $isFullscreenMode: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 16px;
	min-width: 0;

	@media (min-width: ${Breakpoints.b960}px) {
		flex-direction: row;
		align-items: flex-start;
		gap: 40px;
		overflow: hidden;

		> * {
			min-width: 0;
		}
	}

	${({ $isFullscreenMode }) => $isFullscreenMode && DoubleSliderMixin()};
	@media ${landscapeMediaMixin} {
		${DoubleSliderMixin()}
	}
`;
